import request from './axios';
import { baseUrl } from './config';

//获取专题商品
export const apiGetTopicGoods = (paramData) => request({
    url:baseUrl+'/shop/goods/specialGoods/page',
    meta:{isToken:false},
    method:'get',
    params:paramData,
})

//获取专题信息
export const apiGetTopicInfo = (paramData) => request({
    url:baseUrl+'/shop/goods/special/getById',
    meta:{isToken:false},
    method:'get',
    params:paramData,
})

